var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("loading-skeleton", { attrs: { "loading-text": "Searching..." } })
        : _c(
            "div",
            [
              this.emptySearchResults == "yes"
                ? _c("h1", { staticClass: "no-results" }, [
                    _vm._v(
                      "\n        No properties have been found in this area. Please see surrounding\n        suburbs.\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(this.locallist, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticStyle: { padding: "10px 0" } },
                  [
                    item.adImageUrl
                      ? _c(
                          "el-row",
                          {
                            staticStyle: {
                              padding: "40px 0 40px 0",
                              "background-color": "#ffffff"
                            }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center"
                                },
                                attrs: { span: 24 }
                              },
                              [
                                _c("img", {
                                  staticClass: "ads",
                                  staticStyle: {
                                    width: "92.5%",
                                    "object-fit": "cover"
                                  },
                                  attrs: {
                                    id: _vm.getAdId(item.adNumber),
                                    src: item.adImageUrl,
                                    loading: "lazy"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.goAdLink(item.adImageUrlClick)
                                    }
                                  }
                                })
                              ]
                            )
                          ],
                          1
                        )
                      : _c(
                          "el-row",
                          {
                            staticStyle: { display: "flex", padding: "0 16px" }
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: { cursor: "pointer" },
                                attrs: { span: 24 }
                              },
                              [
                                _c(
                                  "el-row",
                                  { staticClass: "search-result-wrapper" },
                                  [
                                    _c(
                                      "el-col",
                                      {
                                        staticClass: "container",
                                        staticStyle: {
                                          display: "flex",
                                          "justify-content": "center",
                                          "background-color": "#ffffff",
                                          overflow: "hidden"
                                        },
                                        attrs: { span: 24 }
                                      },
                                      [
                                        _vm.isWithinLastTenDays(item.launchDate)
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "brand-new-listing",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goPropertyDetails(
                                                      item.propertyId
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Brand New Listing")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.availableRooms > 0 &&
                                        item.availableRooms < 5
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "remaining-properties",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goPropertyDetails(
                                                      item.propertyId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "Only " +
                                                    _vm._s(
                                                      item.availableRooms
                                                    ) +
                                                    " Remaining..."
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("el-image", {
                                          staticStyle: {
                                            height: "100%",
                                            width: "100%"
                                          },
                                          attrs: {
                                            fit: "cover",
                                            src: item.imgFirst
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.goPropertyDetails(
                                                item.propertyId
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          {
                                            style:
                                              "background-color:" +
                                              item.companyColour +
                                              ";",
                                            attrs: { span: 24 }
                                          },
                                          [
                                            _c(
                                              "el-row",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "space-between"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "agency-logo",
                                                      attrs: {
                                                        fit: "fill",
                                                        src: item.companyLogoUrl
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.goPropertyDetails(
                                                            item.propertyId
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-col",
                                                  { attrs: { span: 12 } },
                                                  [
                                                    _c(
                                                      "el-row",
                                                      [
                                                        _c(
                                                          "el-col",
                                                          {
                                                            staticClass:
                                                              "agent-name-wrapper",
                                                            attrs: { span: 16 }
                                                          },
                                                          [
                                                            _c(
                                                              "el-row",
                                                              {
                                                                staticStyle: {
                                                                  display:
                                                                    "flex",
                                                                  "align-items":
                                                                    "center",
                                                                  "justify-content":
                                                                    "center"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "agent-name-style",
                                                                    style:
                                                                      "color:" +
                                                                      _vm.generateAgentNameColour(
                                                                        item.companyColour
                                                                      ) +
                                                                      ";"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.firstName1 +
                                                                          " " +
                                                                          item.lastName1
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 8 }
                                                          },
                                                          [
                                                            _c("el-avatar", {
                                                              staticClass:
                                                                "agent-img",
                                                              attrs: {
                                                                src:
                                                                  item.imageUrl1
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-col",
                                      {
                                        staticStyle: { display: "flex" },
                                        attrs: { span: 24 }
                                      },
                                      [
                                        _c(
                                          "el-card",
                                          {
                                            staticClass: "card-style",
                                            attrs: { shadow: "never" }
                                          },
                                          [
                                            _c(
                                              "el-col",
                                              {
                                                staticStyle: {
                                                  "padding-left": "10px"
                                                },
                                                attrs: { span: 24 }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "z-index": "-1"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.goPropertyDetails(
                                                          item.propertyId
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "el-row",
                                                      { attrs: { gutter: 20 } },
                                                      [
                                                        _c(
                                                          "el-col",
                                                          {
                                                            attrs: { span: 24 }
                                                          },
                                                          [
                                                            _c(
                                                              "el-row",
                                                              {
                                                                staticStyle: {
                                                                  "margin-bottom":
                                                                    "5px"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    attrs: {
                                                                      span: 12,
                                                                      stype:
                                                                        "padding-top: 20px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "property-type-chip"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.proertyType
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-row",
                                                              [
                                                                _c(
                                                                  "el-col",
                                                                  {
                                                                    staticStyle: {
                                                                      display:
                                                                        "flex",
                                                                      "flex-direction":
                                                                        "column",
                                                                      "justify-content":
                                                                        "space-between"
                                                                    },
                                                                    attrs: {
                                                                      span: 24
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-row",
                                                                      [
                                                                        _c(
                                                                          "el-col",
                                                                          {
                                                                            staticStyle: {
                                                                              display:
                                                                                "flex",
                                                                              "flex-direction":
                                                                                "column",
                                                                              "justify-content":
                                                                                "flex-start",
                                                                              "padding-left":
                                                                                "12px"
                                                                            },
                                                                            attrs: {
                                                                              span: 18
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "el-row",
                                                                                      [
                                                                                        _c(
                                                                                          "el-col",
                                                                                          {
                                                                                            staticStyle: {
                                                                                              display:
                                                                                                "flex",
                                                                                              "flex-direction":
                                                                                                "row",
                                                                                              "justify-content":
                                                                                                "space-between"
                                                                                            },
                                                                                            attrs: {
                                                                                              span: 24
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "div-suburb omit"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    _vm.generateDisplayAddress(
                                                                                                      item.address,
                                                                                                      item.suburb
                                                                                                    )
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "el-row",
                                                                                      [
                                                                                        _c(
                                                                                          "el-col",
                                                                                          {
                                                                                            attrs: {
                                                                                              span: 24
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "div-state"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    _vm.generateDisplayStateAndPostcode(
                                                                                                      item.state,
                                                                                                      item.postcode
                                                                                                    )
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "el-col",
                                                                          {
                                                                            staticStyle: {
                                                                              padding:
                                                                                "0 12px",
                                                                              display:
                                                                                "flex",
                                                                              "justify-content":
                                                                                "flex-end",
                                                                              "z-index":
                                                                                "5"
                                                                            },
                                                                            attrs: {
                                                                              span: 6
                                                                            }
                                                                          }
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-row",
                                                                      [
                                                                        _c(
                                                                          "el-col",
                                                                          {
                                                                            staticStyle: {
                                                                              padding:
                                                                                "12px",
                                                                              display:
                                                                                "flex",
                                                                              "justify-content":
                                                                                "flex-start",
                                                                              "padding-left":
                                                                                "12px"
                                                                            },
                                                                            attrs: {
                                                                              span: 24
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-row",
                                                                              {
                                                                                attrs: {
                                                                                  gutter: 20
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "el-row",
                                                                                      [
                                                                                        item.price ==
                                                                                          0 &&
                                                                                        item.price ==
                                                                                          0
                                                                                          ? _c(
                                                                                              "el-col",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "price-style",
                                                                                                attrs: {
                                                                                                  span: 24
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                          Make an offer\n                                        "
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          : _c(
                                                                                              "el-col",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "price-style",
                                                                                                attrs: {
                                                                                                  span: 24
                                                                                                }
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "\n                                          " +
                                                                                                    _vm._s(
                                                                                                      item.price !=
                                                                                                        0
                                                                                                        ? "$" +
                                                                                                            item.price
                                                                                                        : ""
                                                                                                    ) +
                                                                                                    "\n                                          " +
                                                                                                    _vm._s(
                                                                                                      item.maxPrice !=
                                                                                                        0
                                                                                                        ? " - $" +
                                                                                                            item.maxPrice
                                                                                                        : ""
                                                                                                    ) +
                                                                                                    "\n                                        "
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                      ],
                                                                                      1
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-row",
                                                                      [
                                                                        _c(
                                                                          "el-col",
                                                                          {
                                                                            staticClass:
                                                                              "property-description-wrapper",
                                                                            attrs: {
                                                                              span: 24
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    item.proertyType ==
                                                                                    _vm.landOnly
                                                                                      ? _c(
                                                                                          "snapshot-feature",
                                                                                          {
                                                                                            attrs: {
                                                                                              feature:
                                                                                                item.estimatedSettled,
                                                                                              "feature-text":
                                                                                                "Estimated Settlement",
                                                                                              "property-type":
                                                                                                item.proertyType
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    item.proertyType ==
                                                                                    _vm.landOnly
                                                                                      ? _c(
                                                                                          "snapshot-feature",
                                                                                          {
                                                                                            attrs: {
                                                                                              feature:
                                                                                                item.titlesIssued,
                                                                                              "feature-text":
                                                                                                "Title Issued",
                                                                                              "property-type":
                                                                                                item.proertyType
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    item.proertyType ==
                                                                                    _vm.landOnly
                                                                                      ? _c(
                                                                                          "snapshot-feature",
                                                                                          {
                                                                                            attrs: {
                                                                                              feature: _vm.getLandSizeValue(
                                                                                                item
                                                                                              ),
                                                                                              "feature-text":
                                                                                                "Land Size",
                                                                                              "property-type":
                                                                                                item.proertyType
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    item.proertyType ==
                                                                                      _vm.apartment ||
                                                                                    item.proertyType ==
                                                                                      _vm.houseLand ||
                                                                                    item.proertyType ==
                                                                                      _vm.townhouse ||
                                                                                    item.proertyType ==
                                                                                      _vm.house
                                                                                      ? _c(
                                                                                          "snapshot-feature",
                                                                                          {
                                                                                            attrs: {
                                                                                              feature:
                                                                                                item.estimatedCommenceMent,
                                                                                              "feature-text":
                                                                                                "Estimated Commencement",
                                                                                              "property-type":
                                                                                                item.proertyType
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    item.proertyType ==
                                                                                      _vm.apartment ||
                                                                                    item.proertyType ==
                                                                                      _vm.houseLand ||
                                                                                    item.proertyType ==
                                                                                      _vm.townhouse ||
                                                                                    item.proertyType ==
                                                                                      _vm.house
                                                                                      ? _c(
                                                                                          "snapshot-feature",
                                                                                          {
                                                                                            attrs: {
                                                                                              feature:
                                                                                                item.estimatedCompletion,
                                                                                              "feature-text":
                                                                                                "Estimated Completion",
                                                                                              "property-type":
                                                                                                item.proertyType
                                                                                            }
                                                                                          }
                                                                                        )
                                                                                      : _vm._e()
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "snapshot-feature",
                                                                                      {
                                                                                        attrs: {
                                                                                          feature:
                                                                                            item.contractType,
                                                                                          "feature-text":
                                                                                            "Contract Type",
                                                                                          "property-type":
                                                                                            item.proertyType
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "el-row",
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    attrs: {
                                                                                      span: 24
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "snapshot-feature",
                                                                                      {
                                                                                        attrs: {
                                                                                          feature:
                                                                                            item.incentives,
                                                                                          "feature-text":
                                                                                            "Incentives",
                                                                                          "property-type":
                                                                                            item.proertyType
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "el-row",
                                                                      [
                                                                        _c(
                                                                          "el-col",
                                                                          {
                                                                            staticStyle: {
                                                                              padding:
                                                                                "0 12px",
                                                                              display:
                                                                                "flex",
                                                                              "justify-content":
                                                                                "flex-start"
                                                                            },
                                                                            attrs: {
                                                                              span: 24
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "el-row",
                                                                              {
                                                                                staticStyle: {
                                                                                  width:
                                                                                    "100%"
                                                                                },
                                                                                attrs: {
                                                                                  gutter: 20
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "el-col",
                                                                                  {
                                                                                    staticStyle: {
                                                                                      padding:
                                                                                        "12px",
                                                                                      display:
                                                                                        "flex",
                                                                                      "justify-content":
                                                                                        "flex-end"
                                                                                    },
                                                                                    attrs: {
                                                                                      span: 12,
                                                                                      offset: 12
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        staticClass:
                                                                                          "btn-primary contact-agent-btn",
                                                                                        on: {
                                                                                          click: function(
                                                                                            $event
                                                                                          ) {
                                                                                            $event.stopPropagation()
                                                                                            return _vm.contactAgent(
                                                                                              $event
                                                                                            )
                                                                                          }
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Contact Agent"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("el-row")
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.contactDialogVisible
                              ? _c("contact-agent-dialog", {
                                  attrs: {
                                    "contact-dialog-visible":
                                      _vm.contactDialogVisible,
                                    "property-id": item.propertyId
                                  },
                                  on: {
                                    "update:contactDialogVisible": function(
                                      $event
                                    ) {
                                      _vm.contactDialogVisible = $event
                                    },
                                    "update:contact-dialog-visible": function(
                                      $event
                                    ) {
                                      _vm.contactDialogVisible = $event
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                  ],
                  1
                )
              })
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09c12197", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c12197","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/searchResults.vue
// module id = null
// module chunks = 